import type React from "react";

import { useImageResolver } from "@/api/hooks/useImageResolver";
import type { ImageDto } from "@/api/types";
import bgPlaceholder from "@/assets/images/image-placeholder.png";

interface FahWidgetGraphicsProps {
  image: ImageDto | undefined;
}

export function FahWidgetGraphics({ image }: FahWidgetGraphicsProps): React.ReactNode {
  const resolveImage = useImageResolver();

  const src = image ? resolveImage(image, "intrinsic") : undefined;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 350 405">
      <defs>
        <clipPath id="house-inside">
          <path
            fill="#fff"
            fillRule="evenodd"
            d="M30 375V205L175 38.95 320 205v170h-74V240a8 8 0 0 0-8-8H112a8 8 0 0 0-8 8v135H30Z"
            clipRule="evenodd"
          />
        </clipPath>
      </defs>
      <foreignObject x="0" y="0" width="350" height="405" clipPath="url(#house-inside)">
        <div
          aria-description="Project banner image"
          className="size-full bg-aop-dark-blue-500 bg-cover bg-center"
          style={{
            backgroundImage: src ? `url(${src})` : `url(${bgPlaceholder})`,
          }}
        />
      </foreignObject>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M175 0c4.495 0 8.768 1.951 11.701 5.344L346.26 189.901a15.343 15.343 0 0 1 3.74 10.036V397a8 8 0 0 1-8 8H224c-4.431 0-7.292-3.142-7.885-6.641A8.014 8.014 0 0 1 216 397V262h-82v135a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V199.937c0-3.684 1.327-7.245 3.74-10.036L163.3 5.344A15.467 15.467 0 0 1 175 0ZM30 205v170h74V240a8 8 0 0 1 8-8h126a8 8 0 0 1 8 8v135h74V205L175 38.95 30 205Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
